import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  allowWithoutMfa?: boolean;
  allowWithoutMfaVerification?: boolean;
}

const LoadingScreen = () => (
  <Box
    sx={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      bgcolor: 'background.default',
    }}
  >
    <CircularProgress color="primary" />
  </Box>
);

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  allowWithoutMfa = false,
  allowWithoutMfaVerification = false,
}) => {
  const { user, loading, isAdmin, mfaEnrolled, mfaVerified } = useAuth();
  const location = useLocation();

  if (loading) {
    return <LoadingScreen />;
  }

  if (!user || !isAdmin) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (!mfaEnrolled && !allowWithoutMfa) {
    return <Navigate to="/mfa-setup" replace />;
  }

  if (mfaEnrolled && !mfaVerified && !allowWithoutMfaVerification && !allowWithoutMfa) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
